(ns ui.components.radix-ui.context-menu.view
  (:require
   [reagent.core :as r]
   ["@radix-ui/react-context-menu" :as ContextMenu]
   [oops.core :as oops]))

(defn adapt
  [cls-name]
  (r/adapt-react-class (oops/oget+ ContextMenu cls-name)))

(def context-menu (adapt "Root"))
(def trigger (adapt "Trigger"))
(def portal (adapt "Portal"))
(def content (adapt "Content"))
(def label (adapt "Label"))
(def item (adapt "Item"))
(def item-indicator (adapt "ItemIndicator"))
(def group (adapt "Group"))
(def checkbox-item (adapt "CheckboxItem"))
(def radio-group (adapt "RadioGroup"))
(def radio-item (adapt "RadioItem"))
(def sub (adapt "Sub"))
(def sub-trigger (adapt "SubTrigger"))
(def sub-content (adapt "SubContent"))
(def separator (adapt "Separator"))
